export const DELETE_REQUIRED_ITEM = "DELETE_REQUIRED_ITEM";

export default function deleteRequiredItem(questionId, repeatId) {
  return {
    type: DELETE_REQUIRED_ITEM,
    payload: { questionId, repeatId },
  };
}
